import React from "react";
import { Typography, Image } from "antd";
import './FlowDiagram.css';
const { Title, Paragraph } = Typography;

const FlowDiagram = () => {
  return (
    <div>
      <Title level={1}>MERCAWAY Process Flow Diagram</Title>

      <Image
        src="/images/workers-heat-exchanger.jpg"
        alt="heat exchange worker"
        preview={false}
      />
      <figure >
        <div className="Flowdiagram-img">
        <Image
          src="/images/flow-diagram-mercaway-web.png"
          alt="flow diagram"
          preview={false}
        />
        </div>
        <div className="common-paragraph">
        <figcaption>
          Click <a target="_blank" href="/documents/F1305820.pdf" rel="noopener noreferrer">here</a>{" "}
          to view a larger image.
        </figcaption>
        </div>
      </figure>

      <Title level={4}>Removing Mercury from Crude Oil</Title>

      <Paragraph className="Flowdiagram-heading">
        Health, safety and environmental:
      </Paragraph>
      <ul className="common-paragraph">
        <li>May allow acceptable mercury disposal</li>
        <li>Lowers risk to industry personnel</li>
        <li>Lowers equipment impact</li>
        <li>Reduces potential for environmental release of mercury</li>
      </ul>

      <Paragraph className="Flowdiagram-heading">
        Reliability:
      </Paragraph>
      <ul className="common-paragraph">
        <li>Protects equipment from failure due to mercury-induced liquid metal embrittlement</li>
      </ul>

      <Paragraph className="Flowdiagram-heading">
        For oil producers:
      </Paragraph>
      <ul className="common-paragraph">
        <li>Reducing mercury increases crude value and market</li>
      </ul>

      <Paragraph className="Flowdiagram-heading">
        For oil refiners:
      </Paragraph>
      <ul className="common-paragraph">
        <li>Reducing mercury allows processing of more high-mercury crudes with considerable value added</li>
      </ul>

      <Paragraph className="common-paragraph">
        One should consider licensing MERCAWAY&#8480; technology to reduce mercury in crude or
        condensate.
      </Paragraph>
      <div className="Flowdiagram-img">
      <Image 
        src="/images/flow-diagram-map.jpg"
        alt="flow diagram map"
        preview={false}
      />
      </div>
    </div>
  );
};

export default FlowDiagram;